module.exports = __webpack_public_path__ + "img/20MY_PH_EU_LHD_INSTYLE_SEAT_190523.c2fac645.jpg";